import ExaminationQuestions from './ExaminationQuestions';

export default ExaminationQuestions;
